import {GenericInAppNotificationDetailResponse, GenericInAppNotificationResponse} from "../../types/notificationType";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {notificationApi} from "../../api/notificationApi";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Divider,
    Stack,
    Typography
} from "@mui/material";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";

interface Props {
    notification: GenericInAppNotificationResponse;
    onClose: () => void;
}
export default function GenericNotificationDetailDialog(props: Props) {
    const { t } = useTranslation();
    const [detail, setDetail] = useState<GenericInAppNotificationDetailResponse | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        notificationApi.getGenericInAppNotificationDetail(props.notification.id!)
            .then(result => {
                if (result.success()) {
                    setDetail(result.result);
                }
            })
            .finally(() => setIsLoading(false));
    }, [props.notification.id]);

    return (
        <Dialog open={true} fullWidth maxWidth="sm" onClose={props.onClose}>
            <DialogTitle>{props.notification.title}</DialogTitle>

            <DialogContent>
                {isLoading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Stack sx={{ gap: 2 }}>
                        <Box>
                            <Typography variant="subtitle2" gutterBottom>
                                {t("genericInAppNotificationsPage.detail.readBy")} ({detail?.readBy.length ?? 0})
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ maxHeight: 200, overflowY: "auto" }}>
                                <Stack sx={{ gap: 1 }}>
                                    {detail?.readBy.map(r => (
                                        <Box key={r.employee.id} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <CheckCircleOutlined fontSize="small" color="success" />
                                                <Typography>{r.employee.firstName} {r.employee.lastName}</Typography>
                                            </Box>
                                            <Typography variant="body2" color="text.secondary">
                                                {dayjs(r.seenTimestamp + "Z").format("DD.MM.YYYY HH:mm")}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Box>
                        </Box>

                        <Box>
                            <Typography variant="subtitle2" gutterBottom>
                                {t("genericInAppNotificationsPage.detail.unreadBy")} ({detail?.unreadBy.length ?? 0})
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ maxHeight: 200, overflowY: "auto" }}>
                                <Stack sx={{ gap: 1 }}>
                                    {detail?.unreadBy.map(e => (
                                        <Box key={e.id} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <RadioButtonUnchecked fontSize="small" sx={{ color: "text.disabled" }} />
                                            <Typography color="text.secondary">{e.firstName} {e.lastName}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Box>
                        </Box>
                    </Stack>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={props.onClose}>
                    {t("buttons.close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}